import { Avatar, Box, Paper, Stack, TextField, Typography } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import EntriliaMarkIcon from "@entrilia/shared/icons/EntriliaMarkIcon";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";

interface Props {
  value: string;
}

const WorkflowSystemPrompt = ({ value }: Props) => {
  return (
    <Paper variant="outlined" sx={(t) => ({ p: 2, bgcolor: t.palette.background.grey })}>
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Avatar
            sx={(t) => ({
              width: 24,
              height: 24,
              bgcolor: makeTintedBackgroundFromColor(t, t.palette.text.primary),
            })}
          >
            <EntriliaMarkIcon color="secondary" sx={{ width: 16, height: 16 }} />
          </Avatar>
          <Typography>System Prompt</Typography>
          <StatusChip label="Read-only" color={(t) => t.palette.text.secondary} />
        </Stack>

        <Box sx={{ pl: 4 }}>
          <TextField fullWidth multiline rows={12} value={value} slotProps={{ input: { readOnly: true } }} />
        </Box>
      </Stack>
    </Paper>
  );
};

export default WorkflowSystemPrompt;
